/* globals jQuery, ESN */
jQuery( $ => {
	// =========================
	// ! Elements
	// =========================

	const $document = $( document );
	const $body = $( 'body' );

	// =========================
	// ! Supports Flagging
	// =========================

	$body.removeClass( 'nojs' ).addClass( 'js' );

	$document
		.on( 'touchstart', () => {
			$body.removeClass( 'notouch' ).addClass( 'touch' );
		} )
		.on( 'mousedown', () => {
			$body.addClass( 'using-mouse' );
		} )
		.on( 'keydown', () => {
			$body.removeClass( 'using-mouse' );
		} );

	// =========================
	// ! Scroll-to Handling
	// =========================

	const headerHeight = $( '.page-header' ).outerHeight() || 0;
	const scrollOffset = $( 'body' ).hasClass( 'admin-bar' ) ? 32 : 0;

	setTimeout( function() {
		const hash = window.location.hash;
		if ( hash === '#' ) {
			return;
		}

		const $target = $( hash );
		if ( $target.length > 0 ) {
			$( 'html,body' ).animate( { scrollTop: $target.offset().top - ( headerHeight + scrollOffset ) }, 100 );
			if ( $target.hasClass( 'esn-accordion__header closed' ) ) {
				$target.click();
			}
		}
	}, 100 );

	$( 'a[href^="#"]' ).click( function( e ) {
		e.preventDefault();
		const target = $( this ).attr( 'href' );

		if ( target === '#top' ) {
			$( 'html,body' ).animate( { scrollTop: 0 } );
			return;
		}

		const $target = $( target );

		if ( $target.length > 0 ) {
			if ( $target.parent().hasClass( 'esn-accordion__header closed' ) ) {
				$target.parent().trigger( 'click' );
			} else
			if ( $target.parents( '.esn-accordion' ).length > 0 ) {
				$target.parents( '.esn-accordion' ).find( '.esn-accordion__header' ).trigger( 'click' );
			}

			$( 'html,body' ).animate( { scrollTop: $target.offset().top - ( headerHeight + scrollOffset ) } );
		}
	} );

	// =========================
	// ! Accordion
	// =========================

	$( '.esn-accordion__header' ).each( function() {
		const $parent = $( this ).parents( '.esn-accordion-group' ).first();
		const $header = $( this );
		const $target = $header.next();

		$header.click( function() {
			$header.toggleClass( 'is-active' );
			if ( $header.hasClass( 'is-active' ) ) {
				$target.addClass( 'open' ).stop().hide().animate( { height: 'toggle' }, () => $target.attr( 'style', '' ) );
				$parent.find( '.esn-accordion__header' ).not( $header ).each( function() {
					if ( $( this ).hasClass( 'is-active' ) ) {
						$( this ).removeClass( 'is-active' );
						$( this ).next().stop().show().animate( { height: 'toggle' }, () => $( this ).next().attr( 'style', '' ).removeClass( 'open' ) );
					}
				} );
			} else {
				$target.stop().show().animate( { height: 'toggle' }, () => $target.attr( 'style', '' ).removeClass( 'open' ) );
			}
		} );
	} );

	// =========================
	// ! Action Buttons
	// =========================

	$( '.is-action-vote[value]' ).click( function() {
		const $button = $( this ).attr( 'disabled', true );

		$.ajax( {
			url: ESN.url_vote,
			type: 'PUT',
			beforeSend( xhr ) {
				xhr.setRequestHeader( 'X-WP-Nonce', ESN.nonce );
			},
			data: {
				review_id: $button.val(),
			},
			success( data ) {
				$button.text( data.text );
			},
		} );
	} );

	$( '.is-action-subscribe[value]' ).click( function() {
		const $button = $( this );

		$.ajax( {
			url: ESN.url_subscribe,
			type: 'PUT',
			beforeSend( xhr ) {
				xhr.setRequestHeader( 'X-WP-Nonce', ESN.nonce );
			},
			data: {
				review_id: $button.val(),
				unsubscribe: $button.hasClass( 'is-subscribed' ),
			},
			success( data ) {
				$button.toggleClass( 'is-subscribed', data.subscribed );
			},
		} );
	} );

	$( '.is-action-save[value]' ).click( function() {
		const $button = $( this );

		$.ajax( {
			url: ESN.url_save,
			type: 'PUT',
			beforeSend( xhr ) {
				xhr.setRequestHeader( 'X-WP-Nonce', ESN.nonce );
			},
			data: {
				review_id: $button.val(),
				unsave: $button.hasClass( 'is-saved' ),
			},
			success( data ) {
				$button.toggleClass( 'is-saved', data.saved );
			},
		} );
	} );

	// =========================
	// ! Filter Handling
	// =========================

	const $filters = $( '.esn-filter' );

	$( '.esn-filter__toggle' ).click( function() {
		$( this ).parent().toggleClass( 'in' ).trigger( 'app:toggle' );
	} );

	$filters.on( 'app:toggle', function() {
		if ( $( this ).hasClass( 'in' ) ) {
			$filters.not( this ).removeClass( 'in' );
		}

		$body.toggleClass( 'showing-filter', $filters.filter( '.in' ).length > 0 );
	} );

	$filters.on( 'input', function() {
		$( this ).toggleClass( 'has-checked', $( this ).find( 'input:checked' ).length > 0 );
	} ).trigger( 'input' );

	$( '.esn-filter__clear' ).click( function() {
		$( this ).parents( '.esn-filter' ).find( 'input' ).each( function() {
			this.checked = false;
		} );
	} );

	$( '.esn-filter-search__input' ).each( function() {
		$( this ).autocomplete( {
			minLength: 0,
			source: $( this ).data( 'autocomplete' ),
			appendTo: $( this ).parent(),
			select( event, ui ) {
				event.preventDefault();
				window.location = ui.item.url;
			},
			open( event ) {
				$( event.target ).addClass( 'show-results' );
			},
			close( event ) {
				$( event.target ).removeClass( 'show-results' );
			},
		} ).focus( function() {
			$( this ).autocomplete( 'search', this.value );
		} );
	} );

	$( '.esn-filter-reset' ).click( function() {
		$( '.esn-filter' ).find( 'input' ).attr( 'checked', false );
		$( '#filters' ).submit();
	} );

	$( '.esn-filter-tag' ).click( function() {
		$( `input[name="${ this.name }[]"][value="${ this.value }"]` ).attr( 'checked', false ).trigger( 'input' );
		$( '#filters' ).submit();
	} );

	// =========================
	// ! Special Events
	// =========================

	$( '[data-toggle]' ).click( function( e ) {
		e.preventDefault();

		const toggle = $( this ).data( 'toggle' );

		$body.toggleClass( 'show-' + toggle );
	} );

	$( '.esn-directory-item' ).click( function( e ) {
		if ( $( e.target ).is( 'a' ) || $( e.target ).is( 'button' ) ) {
			return;
		}

		$( this ).find( '.esn-directory-item__title a' ).click();
	} );

	$( document ).click( function( e ) {
		const $target = $( e.target );
		if ( ! $target.is( '[href^="#"]' ) && ! $target.hasClass( 'in' ) && $target.parents( '.in' ).length === 0 ) {
			$( '.in' ).removeClass( 'in' ).trigger( 'app:toggle' );
		}
	} );
} );
